// extracted by mini-css-extract-plugin
export var confirmationHeader = "_ws-0";
export var confirmationIcon = "_ws-1";